module.exports = __webpack_public_path__ + "img/book-6.640ccd24.png";